<template>
    <div class="yes-no-input-container mb-3 checkbox-circle">
        <label>
          <question-display :question="question"></question-display>
        </label>
      <div class="checkWidth">
        <label class="curved-checkbox">
          <input type="radio" value="Yes" v-model="inputValue" @change="updateInput" /> Yes
        </label>
        <label class="curved-checkbox">
          <input type="radio" value="No" v-model="inputValue" @change="updateInput" /> No ... If not, would you please share the reason?
        </label>
      </div>
      <div v-if="inputValue === 'No'" class="mt-3">
        <input
          type="text"
          v-model="additionalInput"
          class="form-check-input form-control"
          placeholder="Please specify"
          @input="updateInput"
        />
      </div>
      <small v-if="showValidation && question.required && !inputValue" class="text-danger">This field is required.</small>
    </div>
  </template>
  
  <script>
  import surveyService from '@/services/surveyService'; // Import the survey service
import QuestionDisplay from '../utils/QuestionDisplay.vue';
  
  export default {
    components: {
      QuestionDisplay
    },
    props: {
      question: Object,
      showValidation: Boolean // Add showValidation prop
    },
    data() {
      const savedAnswer = surveyService.getAnswer(this.question.id) || { answer: '', additional: '' };
      return {
        inputValue: savedAnswer.answer,
        additionalInput: savedAnswer.additional
      };
    },
    methods: {
      updateInput() {
        const answer = { answer: this.inputValue, additional: this.additionalInput };
        surveyService.setAnswer(this.question.id, answer); // Save the answer directly through the service
        this.$emit('input', answer);
      }
    },
    watch: {
      question(newQuestion) {
        const savedAnswer = surveyService.getAnswer(newQuestion.id) || { answer: '', additional: '' };
        this.inputValue = savedAnswer.answer;
        this.additionalInput = savedAnswer.additional;
      }
    }
  };
  </script>